import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectCheckboxMessage: {
		id: 'archives.table.select-cell.labelMessage',
		defaultMessage: 'Select issue {issueKey}',
		description: 'Label for the checkbox to select an issue on archives table',
	},
	selectCheckboxMessageIssueTermRefresh: {
		id: 'archives.table.select-cell.labelMessage-issue-term-refresh',
		defaultMessage: 'Select work item {issueKey}',
		description: 'Label for the checkbox to select an issue on archives table',
	},
});
